/**
 * W-21 隐私政策(公开,无守卫)。视觉真源 design/privacy-policy.html。
 * 正文常量与 App 同源(`PRIVACY_POLICY_TEXT`),含 7 项第三方 SDK 共享清单;FR-13 / NFR-Priv1。
 */
import { ProtocolView } from '@/components/shared/ProtocolView';
import { PRIVACY_POLICY_TEXT } from '@/common/copy/protocols';

export function PrivacyPolicyPage() {
  return (
    <ProtocolView title="隐私政策" text={PRIVACY_POLICY_TEXT} testId="privacy-policy-screen" />
  );
}
